import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Paper
} from '@mui/material';
import { MailOutline } from '@mui/icons-material';
import { ZERDE_PRIMARY } from '../types';

interface UserMailSectionProps {
  mailAddress: string | null;
  hasMailSession: boolean;
}

export const UserMailSection: React.FC<UserMailSectionProps> = ({
  mailAddress,
  hasMailSession
}) => {
  return (
    <Box id="user-section-mail" sx={{ scrollMarginTop: '60px' }}>
      <Paper elevation={0} sx={{ p: 3.5, bgcolor: '#ffffff', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 2px 10px rgba(0,0,0,0.03)' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <MailOutline sx={{ color: ZERDE_PRIMARY, fontSize: 20 }} />
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0f172a' }}>
            Корпоративный почтовый ящик (Carbonio / Zimbra)
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ color: '#64748b', mb: 3 }}>
          Статус учетной записи корпоративной почты zerdegroup.kz
        </Typography>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
          <Paper elevation={0} sx={{ p: 2.2, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600 }}>ПОЧТОВЫЙ АДРЕС</Typography>
            <Typography variant="body1" sx={{ fontWeight: 600, color: '#0f172a', mt: 0.5 }}>
              {mailAddress || <span style={{ color: '#94a3b8', fontStyle: 'italic' }}>Не заполнен</span>}
            </Typography>
          </Paper>

          <Paper elevation={0} sx={{ p: 2.2, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
            <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 600 }}>СТАТУС СЕССИИ</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
              <Chip
                size="small"
                label={hasMailSession ? 'Сессия активна' : 'Не подключена'}
                color={hasMailSession ? 'success' : 'warning'}
                sx={{ fontWeight: 600, borderRadius: '6px' }}
              />
            </Box>
          </Paper>
        </Box>
      </Paper>
    </Box>
  );
};

export default UserMailSection;
